(function () {
  function fmt(c) { var e = c / 100; return '€' + (e % 1 === 0 ? e.toFixed(0) : e.toFixed(2).replace('.', ',')); }
  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var btns = root.querySelectorAll('.filters button');
    var cards = root.querySelectorAll('.card');
    var countEl = root.querySelector('[data-count]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-f');
        var n = 0;
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var cats = ' ' + (c.getAttribute('data-cats') || '') + ' ';
          var show = f === 'alles' || cats.indexOf(' ' + f + ' ') !== -1;
          c.hidden = !show;
          if (show) n++;
        });
        if (countEl) countEl.textContent = n;
      });
    });
    var ship = root.querySelector('[data-hh-ship]');
    function updateShip() {
      if (!ship) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var thr = parseInt(ship.getAttribute('data-threshold'), 10);
        var tot = cart.total_price;
        var left = thr - tot;
        ship.querySelector('[data-ship-msg]').textContent = left > 0 ? ('Nog ' + fmt(left) + ' tot gratis verzending') : 'Jij hebt gratis verzending!';
        ship.querySelector('[data-ship-amt]').textContent = fmt(tot) + ' / ' + fmt(thr);
        ship.querySelector('[data-ship-bar]').style.width = Math.min(100, Math.round(tot / thr * 100)) + '%';
      }).catch(function () {});
    }
    updateShip();
    document.addEventListener('cart:updated', updateShip);
  }
  function all() { document.querySelectorAll('.hh-ks').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', all); } else { all(); }
  document.addEventListener('shopify:section:load', all);
})();